import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const CreateGroupModal = ({ visible = false, setVisible, fuctGet, dataUpdate, isEdit }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addFlag = React.useRef(false);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [groupName, setGroupName] = useState('');
    const [valueOption, setValueOption] = useState({
        value: '2',
        label: t('manager'),
    });
    let optionUserType = [
        {
            value: '2',
            label: t('manager'),
        },
        {
            value: '3',
            label: t('staff'),
        },
        {
            value: '4',
            label: t('approval'),
        },
    ];

    if (dataUpdate?.user_type === '1') {
        optionUserType = [
            {
                value: '1',
                label: t('admin'),
            },
            {
                value: '2',
                label: t('manager'),
            },
            {
                value: '3',
                label: t('staff'),
            },
            {
                value: '4',
                label: t('approval'),
            },
        ];
    }

    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        if (isEdit) {
            setGroupName(dataUpdate.group_nm);
            setValueOption(optionUserType.find((item) => item.value === dataUpdate.user_type));
        } else {
            setGroupName('');
            setValueOption({
                value: '2',
                label: t('manager'),
            });
        }
    }, [dataUpdate]);
    const handleEdit = () => {
        setIsSubmit(true);
        if (addFlag.current === true) return;
        if (!groupName || !valueOption) return toast.error(t('error.param'));

        addFlag.current = true;
        setFlagAddStat(true);

        if (!isEdit) {
            let InVal = [groupName, valueOption.value];
            sendRequest(serviceList.createGroup, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            let InVal = [groupName, valueOption.value, dataUpdate.id];
            sendRequest(serviceList.updateGroup, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();
            setVisible(!visible);
            setIsSubmit(false);
            setGroupName('');
        }
    };
    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            // style={{ minWidth: '650px', width: '100%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {!isEdit ? t('create_group') : t('update_group')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('name_group')}
                            valueChange={groupName}
                            getValue={setGroupName}
                            required
                            error={!groupName && isSubmit}
                            helperText={!groupName && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('group_staff')}
                            valueSelect={valueOption}
                            required
                            getValue={setValueOption}
                            selectOption={optionUserType}
                            disabled={isEdit}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CreateGroupModal;
